import styles from "@components/Video.module.css";

type Props = {
  onPlay?: () => void;
  posterUrl: string | null;
  videoUrl: string;
};

const Video = ({ onPlay, posterUrl, videoUrl }: Props) => (
  <video className={styles.video} controls height="100%" onPlay={onPlay} poster={posterUrl ?? ""} width="100%">
    <source src={videoUrl} type="video/mp4" />
  </video>
);

export default Video;
